export class RestError {
  code: string = "";
  message: string = "";
}
